import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaCheck, FaHotel, FaStar, FaBus } from 'react-icons/fa';
import AccommodationModal from './AccommodationModal';
import TransportModal from './TransportModal';

const EventInfo = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTransportModalOpen, setIsTransportModalOpen] = useState(false);

  return (
    <section className="min-h-screen py-20 px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="max-w-4xl mx-auto"
      >
        <h2 className="text-4xl md:text-5xl font-cursive text-gray-800 mb-16 text-center">
          Todo lo que Necesitas Saber
        </h2>

        <div className="grid md:grid-cols-1 gap-8 max-w-xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="rounded-2xl shadow-xl p-8 flex flex-col items-center text-center"
          >
            <h4 className="text-2xl font-cursive text-[#D4AF37] mb-3">Alojamiento</h4>
            <span className="text-4xl mb-4 text-[#D4AF37]">
              <FaHotel />
            </span>
            <div className="space-y-4">
              <p className="font-serif text-lg">El resort cuenta con habitaciones limitadas para todos los invitados. Te recomendamos confirmar con anticipación para asegurar tu estadía.</p>
              <p className="font-serif text-lg">Si las plazas están completas, habrá alojamientos disponibles cercanos al resort y con servicio de transporte</p>
              <button
                className="bg-[#D4AF37] text-white text-xl px-8 py-3 rounded-full hover:bg-[#C5A028] transition-all duration-300 shadow-md border-2 border-[#FFD700] hover:border-[#D4AF37] hover:shadow-lg active:shadow-inner font-cursive"
                onClick={() => setIsModalOpen(true)}
              >
                Confirmar Estadía
              </button>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
            className="rounded-2xl shadow-xl p-8 flex flex-col items-center text-center"
          >
            <h4 className="text-2xl font-cursive text-[#D4AF37] mb-3">Transporte</h4>
            <span className="text-4xl mb-4 text-[#D4AF37]">
              <FaBus />
            </span>
            <div className="space-y-4">
              <p className="font-serif text-lg">Contaremos con servicio de traslado en trafic desde Córdoba Capital 17:00hs hacia el evento, retornando a las 5:00hs.</p>
              <p className="font-serif text-lg">Los cupos son limitados, por lo que te pedimos confirmar con anticipación si necesitás este servicio.</p>
              <p className="font-serif text-sm italic">Los horarios y puntos de encuentro serán informados más adelante a quienes reserven el traslado.</p>
              <button
                onClick={() => setIsTransportModalOpen(true)}
                className="bg-[#D4AF37] text-white text-xl px-8 py-3 rounded-full hover:bg-[#C5A028] transition-all duration-300 shadow-md border-2 border-[#FFD700] hover:border-[#D4AF37] hover:shadow-lg active:shadow-inner font-cursive"
              >
                Ver Opciones de Transporte
              </button>
            </div>
          </motion.div>
        </div>
      </motion.div>
      <AccommodationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
      <TransportModal
        isOpen={isTransportModalOpen}
        onClose={() => setIsTransportModalOpen(false)}
      />
    </section>
  );
};

export default EventInfo; 